import MUIChartView from '@mui/icons-material/ShowChart'

export const ChartViewIcon = MUIChartView
